import { Response } from '@angular/http';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { isArray } from 'util';

export class ApiErrorHandlerArgModel
{
    public handleDefaultAuthExceptions? : boolean = true;
    public onInvalidToken?: (model : any) => any;
    public onUnauthorized?: (model : any) => any;
}
export class HttpHandlerArgModel extends ApiErrorHandlerArgModel{
    public baseUrl?: string;
    public authorization?: {
        type?               : string,
        headerName?         : string,
        querystringName?    : string,
        authType?           : string
    };
    public header?          : Array<HttpHandlerHeaderArg>;
}
export class HttpHandlerHeaderArg {
    public key: string;
    public value: string;
}
export class HttpHandlerSecurity
{
    public username?        : string;
    public password?        : string;
}
export class HttpHandlerMethodArg extends ApiErrorHandlerArgModel{
    public authorization?: string;
    public url?: string;
    public endpoint?: string;
    public token?: string = '';
    public contentType?: string = 'application/json';
    public header?: Array<HttpHandlerHeaderArg>;
    public endPointId? : string;
    public security? :HttpHandlerSecurity = null;
    public needToken? : boolean = true;
    public onSuccess?: (response: any) => any;
    public onError?: (error: any) => any;
    public onStart?: (HttpHandlerArgModel: any) => any;
    public onEnd?: (HttpHandlerArgModel: any) => any;
}

export class HttpHandlerGetArg extends HttpHandlerMethodArg { }
export class HttpHandlerPostArg extends HttpHandlerMethodArg {
    public model ?          : any;
    public contentType?     : string = 'application/json';
}

export class HttpHandler {
    private _defaultArgs: HttpHandlerArgModel = {
        baseUrl: '',
        authorization: {
            type: 'header',
            headerName: 'authorization',
            querystringName: 'token',
            authType : 'bearer'
        }
    };

    private _args: HttpHandlerArgModel;

    
    constructor(private _http: HttpClient, args: any) {
        this._args = Object.assign(this._defaultArgs, args);
    }

    public Get<T>(arg: HttpHandlerGetArg): Observable<T> {
        arg = Object.assign({
            model: {},
            contentType: 'application/json',
            url : this._args.baseUrl
        }, arg);

        if (arg.onStart && typeof(arg.onStart) === 'function') arg.onStart(arg);

        var headers = new HttpHeaders({
            'Content-Type': arg.contentType
        });

        if(arg.header)
        {
            arg.header.forEach(h => { headers.append(h.key,h.value); });
        }

        try
        {
            var result = this._http.get<T>(this.generateUrl(arg),
            {
                headers: headers
            });
            return result;
        }
        catch(e)
        {
            return null;
        }
    }

    public Post(arg: HttpHandlerPostArg): Observable<Response> {
        if (arg.onStart) arg.onStart(arg);

        arg = Object.assign({
            model: {},
            contentType: 'application/json',
            url : this._args.baseUrl
        }, arg);

        var headers = new HttpHeaders({
            'Content-Type': arg.contentType
        });
        if(this._args.authorization.type.toLowerCase() === 'header' && this._args.authorization.headerName.length && arg.token.length)
        {
            
            headers.append(this._args.authorization.headerName,`${this._args.authorization.authType} ${arg.token}`);
        }
        if(arg.header)
        {
            arg.header.forEach(h => { headers.append(h.key,h.value); });
        }


        var result = this._http.post<Response>(
            this.generateUrl(arg),
            JSON.stringify(arg.model),
            {
                headers : headers
                // headers: new HttpHeaders({
                //     'Content-Type': arg.contentType,
                //     'Authorization': arg.authorization
                // })
            });

        return result;
    }

    public GetResponse<T>(arg: HttpHandlerGetArg): Observable<HttpResponse<T>> {
        arg = Object.assign({},{
            model: {},
            contentType: 'application/json',
            url : this._args.baseUrl,
            header : Object.assign({},(this._args.header || {} ),(arg.header || {}))
        }, arg);
        if (arg.onStart && typeof(arg.onStart) === 'function') arg.onStart(arg);

        var headers = new HttpHeaders({
            'Content-Type': arg.contentType
        });

        if(this._args.authorization.type.toLowerCase() === 'header' && this._args.authorization.headerName.length && arg.token && arg.token.length)
        {
            headers = headers.append(this._args.authorization.headerName,`${this._args.authorization.authType} ${arg.token}`);
        }
        if(arg.header)
        {
            arg.header.forEach(h => { headers = headers.append(h.key,h.value); });
        }
        try
        {
            var result = this._http.get<T>(this.generateUrl(arg),
            {
                headers: headers,
                observe : 'response'
            });
            
            return result;
        }
        catch(e)
        {
            return null;
        }
    }

    public PostResponse<T>(arg: HttpHandlerPostArg): Observable<HttpResponse<T>> {
        arg = Object.assign({},{
            model: {},
            contentType: 'application/json',
            url : this._args.baseUrl,
            header : Object.assign({},(this._args.header || {} ),(arg.header || {}))
        }, arg);

        if(arg.contentType.toLowerCase() === 'application/x-www-form-urlencoded')
        {
            return this.PostUrlEncodedResponse(arg);
        }
        
        if (arg.onStart && typeof(arg.onStart) === 'function') arg.onStart(arg);

        var headers = new HttpHeaders({
            'Content-Type': arg.contentType
        });
        if(this._args.authorization.type.toLowerCase() === 'header' && this._args.authorization.headerName.length && arg.token && arg.token.length)
        {
            headers = headers.append(this._args.authorization.headerName,`${this._args.authorization.authType} ${arg.token}`);
        }
        if(arg.header && isArray(arg.header))
        {
            arg.header.forEach(h => { headers = headers.append(h.key,h.value); });
        }

        try
        {
            var result = this._http.post<T>(
                this.generateUrl(arg),
                JSON.stringify(arg.model),
                {
                    headers: headers,
                    observe : 'response'
                }
            );
            
            return result;
        }
        catch(e)
        {
            return null;
        }
    }

    public PostUrlEncodedResponse<T>(arg: HttpHandlerPostArg): Observable<HttpResponse<T>> {
        arg = Object.assign({},{
            model: {},
            contentType: 'application/x-www-form-urlencoded',
            url : this._args.baseUrl,
            header : Object.assign({},(this._args.header || {} ),(arg.header || {}))
        }, arg);
        
        if(arg.contentType.toLowerCase() === 'application/json')
        {
            return this.PostResponse(arg);
        }

        if (arg.onStart && typeof(arg.onStart) === 'function') arg.onStart(arg);

        var headers = new HttpHeaders({
            'Content-Type': arg.contentType
        });

        if(this._args.authorization.type.toLowerCase() === 'header' && this._args.authorization.headerName.length && arg.token && arg.token.length)
        {
            headers = headers.append(this._args.authorization.headerName,`${this._args.authorization.authType} ${arg.token}`);
        }
        if(arg.header)
        {
            arg.header.forEach(h => { headers = headers.append(h.key,h.value); });
        }
        try
        {
            var result = this._http.post<T>(
                this.generateUrl(arg),
                arg.model,
                {
                    headers: headers,
                    observe : 'response'
                }
            );
            
            return result;
        }
        catch(e)
        {
            return null;
        }
    }

    public PostFormDataResponse<T>(arg: HttpHandlerPostArg): Observable<HttpResponse<T>> {
        arg = Object.assign({},{
            model: {},
            contentType: 'multipart/form-data',
            url : this._args.baseUrl,
            header : Object.assign({},(this._args.header || {} ),(arg.header || {}))
        }, arg);
        
        return this.PostUrlEncodedResponse<T>(arg);
    }

    private generateUrl(model: HttpHandlerMethodArg): string {
        let url = model.url.length ? model.url : this._args.baseUrl;
        let endpoint = model.endpoint || model.url ;

        let result = url;
        let token = '';

        var prefix = `${(endpoint.toLowerCase().startsWith('http://') || endpoint.toLowerCase().startsWith('https://')) ? this.trimEnd(endpoint,'/') : this.trimEnd(url ,'/') + '/' + endpoint}`;
        result = prefix;

        if (this._args.authorization) {
            switch (this._args.authorization.type.toLowerCase().trim()) {
                case ('querystring'):
                    if (this._args.authorization.querystringName.length <= 0) break;
                    let prefix = '?';
                    // اگر در آدرس اینترنتی موجود "؟" داشتیم باید توکن را با "&" اضافه کنیم
                    if (result.indexOf('?') >= 0) { prefix = '&'; }
                    token = `${prefix}${this._args.authorization.querystringName}=${model.token}`;
                    break;
            }
        }

        return `${result}${token}`;
    }

    private trimEnd(str: string, char: string): string {
        if(!str) return '';
        if (char === "]") char = "\\]";
        if (char === "\\") char = "\\\\";
        return str.replace(new RegExp(
            "^[" + char + "]+|[" + char + "]+$", "g"
        ), "");
    }
}